/** Media helpers for WXM page sections — images, videos, YouTube/Vimeo links. */
import React from "react";

export const mediaKind = (url) => {
  if (!url) return "";
  if (url.startsWith("data:image") || /\.(png|jpe?g|webp|gif|svg)(\?|$)/i.test(url)) return "image";
  if (/youtu\.be|youtube\.com/i.test(url)) return "youtube";
  if (/vimeo\.com/i.test(url)) return "vimeo";
  if (/\.(mp4|webm|ogg|mov)(\?|$)/i.test(url)) return "video";
  return "image";
};

export const youtubeId = (url) => (String(url).match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([\w-]{11})/) || [])[1] || "";
export const vimeoId = (url) => (String(url).match(/vimeo\.com\/(?:video\/)?(\d+)/) || [])[1] || "";

export const MediaEmbed = ({ url, className = "" }) => {
  const kind = mediaKind(url);
  if (!kind) return null;
  const frame = `w-full overflow-hidden rounded-2xl shadow-lg ring-1 ring-slate-200 ${className}`;
  if (kind === "youtube") {
    return (
      <div className={`${frame} aspect-video bg-black`}>
        <iframe title="video" src={`https://www.youtube.com/embed/${youtubeId(url)}`}
          className="h-full w-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
      </div>
    );
  }
  if (kind === "vimeo") {
    return (
      <div className={`${frame} aspect-video bg-black`}>
        <iframe title="video" src={`https://player.vimeo.com/video/${vimeoId(url)}`}
          className="h-full w-full" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen />
      </div>
    );
  }
  if (kind === "video") {
    return <video src={url} controls playsInline className={`${frame} bg-black`} />;
  }
  return <img src={url} alt="" loading="lazy" className={`${frame} object-cover`} />;
};

/** HTML-string version for the iframe preview renderer. */
export const mediaHtml = (url) => {
  const kind = mediaKind(url);
  const frame = "width:100%;border-radius:18px;box-shadow:0 10px 30px rgba(15,32,66,.12);border:1px solid #E2E8F0;overflow:hidden";
  if (!kind) return "";
  if (kind === "youtube") return `<div style="${frame};aspect-ratio:16/9;background:#000"><iframe src="https://www.youtube.com/embed/${youtubeId(url)}" style="width:100%;height:100%;border:0" allowfullscreen></iframe></div>`;
  if (kind === "vimeo") return `<div style="${frame};aspect-ratio:16/9;background:#000"><iframe src="https://player.vimeo.com/video/${vimeoId(url)}" style="width:100%;height:100%;border:0" allowfullscreen></iframe></div>`;
  if (kind === "video") return `<video src="${url}" controls playsinline style="${frame};background:#000;display:block"></video>`;
  return `<img src="${url}" alt="" style="${frame};display:block;object-fit:cover"/>`;
};
